import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import HeroLogo from "../assets/logo-asifc.png"
import Logo1 from "../assets/cdddlmdl.png"
import Logo2 from "../assets/cncd.png"
import Logo3 from "../assets/unacof.jpg"
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

function Home() {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <img src={HeroLogo} className='hero-logo' />
          <h1 className="hero-title">Association Solidarité Internationale France Comores Dans le Rhône - ASIFC RHÔNE</h1>
          <p className="hero-subtitle">Contribuer au développement durable des Comores à travers la solidarité internationale</p>
          <div className="hero-buttons">
            {/* <Link to="/benevole" className="btn btn-primary">Devenir bénévole</Link> */}
            {/* <a href="#objectifs" className="btn btn-secondary">Qui sommes-nous ?</a> */}
          </div>
        </div>
      </section>

      {/* Presentation Section */}
      <section className="presentation-section" id="objectifs">
        <div className="container">
          <h2 className="section-title">Qui sommes-nous ?</h2>
          <p className="presentation-text">
            L'ASIFC est une association qui œuvre pour le développement durable des Comores. 
            Nous sommes une famille qui s'ouvre sur le monde chaque jour et qui aime faire 
            connaître son île à tout un chacun.
          </p>
          <p className="presentation-text">
            À travers notre engagement, nous menons, accompagnons et soutenons des projets 
            de solidarité internationale destinés au développement des îles des Comores.
          </p>
        </div>
      </section>

      {/* Objectifs Section */}
      <section className="objectifs-section" id="objectifs">
        <div className="container">
          <h2 className="section-title">Nos engagements</h2>
           <p className="presentation-text">
            Le but est de mener, accompagner ou soutenir des projets de solidarité internationale destinés au développement des îles mais aussi d’accompagner la diaspora sur le territoire français. 
          </p>
          <div className="objectifs-grid">
            <div className="objectif-card">

             <img src={Logo1} className='eng-logo' />
            </div>

            <div className="objectif-card">
             <img src={Logo2} className='eng-logo2' />
            </div>

            <div className="objectif-card">
             <img src={Logo3} className='eng-logo' />
            </div>
          </div>
        </div>
      </section>

      {/* Membres Section */}
      <section className="membres-section" id="membres">
        <div className="container">
          <h2 className="section-title">Notre Équipe</h2>
          <p className="section-subtitle">
            Une équipe passionnée et engagée pour le développement des Comores
          </p>
          <div className="membres-grid">
            <div className="membre-card">
              <div className="membre-avatar">👤</div>
              <h3>Laithe MOHAMED HALIFA</h3>
              <p className="membre-role">Président</p>
            </div>

            <div className="membre-card">
              <div className="membre-avatar">👤</div>
              <h3>Djawad MBARAKA</h3>
              <p className="membre-role">Vice-Président</p>
            </div>

            <div className="membre-card">
              <div className="membre-avatar">👤</div>
              <h3>Mohamed DAHALANI</h3>
              <p className="membre-role">Trésorier</p>
            </div>

                  <div className="membre-card">
              <div className="membre-avatar">👤</div>
              <h3>Rabyata ILLIASSA</h3>
              <p className="membre-role">Trésorière adjointe</p>
            </div>

            <div className="membre-card">
              <div className="membre-avatar">👤</div>
              <h3>Halima ILLIASSA</h3>
              <p className="membre-role">Secrétaire</p>
            </div>

            <div className="membre-card">
              <div className="membre-avatar">👤</div>
              <h3>Soulaimana MOHAMED</h3>
              <p className="membre-role">Chargé de communication</p>
            </div>

             <div className="membre-card">
              <div className="membre-avatar">👤</div>
              <h3>Inaya HASSANI</h3>
              <p className="membre-role">Support chargé de communication</p>
            </div>

          
          </div>
        </div>
      </section>

      {/* Informations Section */}
      <section className="infos-section" id="infos">
        <div className="container">
          <h2 className="section-title">Informations Importantes</h2>
          <div className="infos-grid">
            <div className="info-card">
              <h3>Localisation</h3>
              <p>13 avenue Marcel Paul, Vénissieux, France, 69200</p>
            </div>

            <div className="info-card">
              <h3>Réseaux sociaux</h3>
              <div className='social-container'>
                <a className='social-icon-home' href="https://www.facebook.com/p/Association-Solidarit%C3%A9-Internationale-France-Comores-Rh%C3%B4ne-ASIFC-Rh%C3%B4ne-100086731297999/" target="_blank" rel="noopener noreferrer">
                  <FaFacebook size={40} />
                </a>
                <a className='social-icon-home' href="https://www.instagram.com/asifcrhone/" target="_blank" rel="noopener noreferrer">
                  <FaInstagram size={40} />
                </a>

                <a className='social-icon-home' href="https://www.linkedin.com/in/asifc-rhone-006815424/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin size={40} />
                </a>

                
              </div>
            </div>

            <div className="info-card">
              <h3>Contact</h3>
              <p>asifc.rhone@gmail.com</p>
            </div>

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Rejoignez-nous dans notre mission</h2>
          <p>Ensemble, construisons un avenir meilleur pour les Comores</p>
          <Link to="/benevole" className="btn btn-cta">Devenir bénévole</Link>
        </div>
      </section>

    </div>
  );
}

export default Home;